module.exports = __webpack_public_path__ + "img/vocab-cards-design-Tashii-Designs.9db51c09.jpg";